import type {
  FilterConfig,
  FilterDefinition,
  FilterHandler,
} from '../engine/types';
import {
  FilterId,
  FilterType,
  type ListFilter,
  type MultiFilter,
} from '../types/filters';
import { workScheduleDefinition, workScheduleHandler } from './workSchedule';

export const multiWorkScheduleDefinition: FilterDefinition<
  MultiFilter<ListFilter>
> = {
  id: FilterId.MULTI_WORK_SCHEDULE,
  name: 'Work Schedule',
  type: FilterType.MULTI,
  wrappedFilterId: FilterId.WORK_SCHEDULE,
  instances: [],
  isVisible: true,
};

export const multiWorkScheduleHandler: FilterHandler<MultiFilter<ListFilter>> =
  {
    isActive(currentFilterState: MultiFilter<ListFilter>) {
      return currentFilterState.instances.some((instance) =>
        workScheduleHandler.isActive(instance)
      );
    },

    isDefault(currentFilterState: MultiFilter<ListFilter>) {
      return currentFilterState.instances.length === 0;
    },

    getEffectiveFilter(
      currentFilterState: MultiFilter<ListFilter>,
      _definition: FilterDefinition<MultiFilter<ListFilter>>,
      config: FilterConfig
    ) {
      const effectiveInstances = currentFilterState.instances.map((instance) =>
        workScheduleHandler.getEffectiveFilter(
          instance,
          workScheduleDefinition,
          config
        )
      );
      return { ...currentFilterState, instances: effectiveInstances };
    },
  };
